export default __webpack_public_path__ + "static/media/bankWire.7d16dfe8.svg";